import { render, staticRenderFns } from "./TabStaffSession.vue?vue&type=template&id=89caaeaa"
import script from "./TabStaffSession.vue?vue&type=script&lang=js"
export * from "./TabStaffSession.vue?vue&type=script&lang=js"
import style0 from "./TabStaffSession.vue?vue&type=style&index=0&id=89caaeaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports